var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',[_vm._v(_vm._s(_vm.paso)+" de "+_vm._s(_vm.config.cantPasos()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }